module.exports = __webpack_public_path__ + "media/2.2_super_adjectives_tarjeta_avatar_student_cf1.a88737ff.wav";